<div class="new-modal">
  <div class="title__wrapper">
    <div class="confirm-modal-title">
      <svg-icon
        *ngIf="modalData.titleIcon"
        class="confirm-modal-title__icon"
        [src]="modalData.titleIcon"
      />
      <span class="title">{{ modalData.title | translate }}</span>
    </div>
    <svg-icon
      class="clear-icon ml-2 align-self-start"
      src="/assets/img/close-icon.svg"
      (click)="dialogRef.close()"
    />
  </div>

  <div class="new-modal__content">
    <p>{{ modalData.body | translate }}</p>
  </div>

  <div class="d-flex justify-content-end mt-4">
    <app-button
      (onClick)="onCancel()"
      [config]="{
        text: modalData.cancelButtonText | translate,
        type: ButtonTypes.NEW_SECONDARY_BLUE,
        size: ButtonSize.LARGE,
        smSize: ButtonSize.SMALL
      }"
    />

    <app-button
      [class]="'ml-2'"
      (onClick)="onSubmit()"
      [config]="{
        text: modalData.submitButtonText | translate,
        type: modalData.submitButtonType,
        size: ButtonSize.LARGE,
        smSize: ButtonSize.SMALL,
        appendSrc: modalData.submitButtonIcon
      }"
    />
  </div>
</div>
